"use client";

import type { ReactNode } from "react";
import Image from "next/image";
import Link from "next/link";
import { fixMaybeBrokenText } from "@/lib/text-client";

type MobileCategoryTile = {
  slug: string;
  name: string;
  previewImage: string;
};

export function MobileCategoryTiles({
  categories,
  title = "Разделы каталога",
  description,
  action
}: {
  categories: MobileCategoryTile[];
  title?: string;
  description?: string;
  action?: ReactNode;
}) {
  if (!categories.length) {
    return null;
  }

  return (
    <section aria-labelledby="mobile-category-section-title" className="quick-tiles">
      <div className="quick-tiles__header">
        <div className="quick-tiles__copy">
          <h2 className="quick-tiles__title" id="mobile-category-section-title">
            {fixMaybeBrokenText(title)}
          </h2>
          {description ? <p className="quick-tiles__description">{fixMaybeBrokenText(description)}</p> : null}
        </div>
        {action ? <div className="quick-tiles__action">{action}</div> : null}
      </div>

      <div className="quick-tiles__grid">
        {categories.map((category) => (
          <Link className="quick-tiles__item" href={`/category/${category.slug}`} key={category.slug}>
            <span className="quick-tiles__item-media">
              <Image
                alt={fixMaybeBrokenText(category.name)}
                height={96}
                loading="lazy"
                sizes="96px"
                src={category.previewImage}
                width={96}
              />
            </span>
            <span className="quick-tiles__item-name">{fixMaybeBrokenText(category.name)}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
